module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "confirm-ilustra.2a83de25.png";